export const ASSESSMENT_EXTENUATING_CIRCUMSTANCES = `/ec-submit`
export const ASSESSMENT_EXTENUATING_CIRCUMSTANCES_ADMIN = `/ec`
